export const ReadOTPReceived = (onSMSReceived) => {

};

export const RemoveSmsListenerIfRegistered = () => {

}